import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {Grid, IconButton, Typography} from '@mui/material';
import api from '../../../services/api';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Joyride, {STATUS, Step} from "react-joyride";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {GroupCard} from "../components/GroupCard";


// --- CONFIG ---
const LS_KEY = "guideTraining.completed";
interface Props {}

export const GuideSchedulePage: React.ComponentType<Props> = ({}) => {
  const [rows, setRows] = useState<any>([]);
  const [date, setDate] = useState<any>('');
  const [loading, setLoading] = useState<any>(false);

  const [steps, setSteps] = useState<Step[]>([
    {
      target: "body",
      placement: "center",
      title: "Welcome",
      content: "We’ll guide you through the key elements.",
      disableBeacon: true,
    },
    {
      target: "#section-dates",
      title: "Dates",
      content: "Here you can see the time range during which the groups will be listed",
      placement: "bottom",
    },
  ]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    await api
      .get(`/guide/guide-schedule`)
      .then((result: any) => {
        setRows(result?.rows);
        setDate(result?.date);
        setLoading(false);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    fetchData();
  }, []);


  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  // Indítsd el automatikusan első látogatáskor
  useEffect(() => {
    const completed = localStorage.getItem(LS_KEY) === "true";
    if (!completed) {
      setRun(true);
    }
  }, []);

  const handleJoyride = (data: any) => {
    const { status, index, type } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Jelöld készre, hogy legközelebb ne induljon el automatikusan
      localStorage.setItem(LS_KEY, "true");
      setRun(false);
      setStepIndex(0);
    } else if (type === "step:after") {
      setStepIndex(index + 1);
    }
  };

  const startTraining = () => {
    setStepIndex(0);
    setRun(true);
  };

  const handleRegisterSteps = useCallback((childSteps: Step[]) => {
    setSteps(prev => [...prev, ...childSteps]); // fűzd hozzá a gyerek lépéseit
  }, []);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          overflow: 'auto',
          p: '10px'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AppBar
              sx={{
                background: '#fefefe',
                color: '#666',
                borderRadius: '10px',
              }}
              position="static"
            >
              <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  Guide Schedule
                </Typography>
                <Typography
                  id={"section-dates"}
                    color="disabled" variant="caption">
                  {date}
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Grid container spacing={2}>
                {rows.map((group: any, index: any) => {
                  return (
                    <Grid key={index} item xs={12} md={4} lg={3}>
                      <GroupCard
                        key={index}
                        item={group}
                        onClick={() => {}}
                        onRegisterSteps={handleRegisterSteps}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Joyride */}
      <Joyride
        run={run}
        steps={steps}
        stepIndex={stepIndex}
        continuous
        showProgress
        showSkipButton
        disableScrolling={false}
        scrollToFirstStep
        styles={{
          options: {
            zIndex: 2000,
          },
          tooltip: {
            borderRadius: '10px',
          },
          buttonNext: {
            background: '#256861'
          },
          buttonBack: { opacity: 0.75 },
        }}
        callback={handleJoyride}
      />

      <IconButton
        sx={{
          background: '#256861',
          boxShadow: '0px 1px 5px 1px #00000054',
          position: 'absolute',
          bottom: 16,
          right: 16,
          '&:hover': {
            background: '#256861',
          },
        }}
        id="btn-training-restart"
        onClick={startTraining}
        aria-label="Tréning újraindítása">
        <HelpOutlineIcon sx={{
          color: '#fff'
        }} />
      </IconButton>
    </>
  );
};

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
